import { AssetScreenerService } from "../services/assetScreener.service"
import { type TokenDO } from "../../tokenData/models/tokenDO.models"
import '../styles/assetScreener.style.scss'
import { formatter } from "../../core/helpers/formatter"
import { AssetScreenerHeaderComponent } from "./assetScreenerHeader.component"
import { type WebflowToken, type Sort } from "../models/assetScreener.models"
export class AssetScreenerComponent extends HTMLElement {
    private webflowTokens: WebflowToken[] = []
    private assetData: TokenDO[] = []
    // No active sort shown in the header by default; data is still initially sorted by name
    private currentSort: Sort = { field: '', direction: 'asc' }

    constructor(private assetScreenerService: AssetScreenerService = window.tbwServices.assetScreenerService) {
        super()
        this.classList.add('asset-screener-container')
    }

    connectedCallback() {
        this.webflowTokens = this.fetchWebflowTokens()
        if (this.webflowTokens.length === 0) {
            // console.log('No slugs found')
            return
        }
        this.init()
    }

    async init() {
        this.assetData = await this.load()
        this.assetData = AssetScreenerHeaderComponent.sortData(
            this.assetData,
            { field: 'name', direction: 'asc' }
        )
        this.createScreener()
        this.style.display = 'flex'
    }

    async createScreener() {
        const table = document.createElement('table')
        this.createHeaderRow(table)
        this.createAssetRows(table)
        this.appendChild(table)
    }

    async createHeaderRow(table: HTMLTableElement) {
        const tHead = table.createTHead()
        const headerComponent = new AssetScreenerHeaderComponent((sort) => {
            this.currentSort = sort
            this.assetData = AssetScreenerHeaderComponent.sortData(this.assetData, sort)
            this.refreshScreener()
        }, this.currentSort)
        tHead.appendChild(headerComponent.getElement())
    }

    async createAssetRows(table: HTMLTableElement) {
        const tBody = table.createTBody()
        this.assetData.forEach((asset) => {
            const row = document.createElement('tr')

            // Puts the token icon in the first column
            row.innerHTML = `
            <td >
                ${this.createTokenCell(asset)}
            </td>
            <td><p class="caption1">${formatter.formatPrice(asset.data.price) ?? ''}</p></td>
            <td style="color: ${this.getColor(asset.data.percent_change_24h)}"><p class="caption1">${formatter.formatPercentage(asset.data.percent_change_24h) ?? ''}</p></td>
            <td style="color: ${this.getColor(asset.data.percent_change_7d)}"><p class="caption1">${formatter.formatPercentage(asset.data.percent_change_7d) ?? ''}</p></td>
            <td style="color: ${this.getColor(asset.data.percent_change_30d)}"><p class="caption1">${formatter.formatPercentage(asset.data.percent_change_30d) ?? ''}</p></td>
            <td><p class="caption1">${formatter.formatLargeNumber(asset.data.market_cap) ?? ''}</p></td>
            <td><p class="caption1">${formatter.formatLargeNumber(asset.data.volume_24h) ?? ''}</p></td>
            <td><p class="caption1">${formatter.formatLargeNumber(asset.data.fully_diluted_market_cap) ?? ''}</p></td>
            `

            tBody.appendChild(row)
        })
    }

    getColor(value: number): string {
        return value < 0 ? 'var(--coral)' : 'var(--green-percentage)'
    }

    async refreshScreener() {
        this.innerHTML = ''
        this.createScreener()
    }

    async load(): Promise<TokenDO[]> {
        const slugsString = this.webflowTokens.map(slug => slug.slug).join(',')
        const screenerData = await this.assetScreenerService.getTokenData(slugsString)

        return screenerData
    }

    //@ts-ignore
    fetchWebflowTokens(): WebflowToken[] | any {
        const slugArray = document.querySelectorAll('[data-token-slug]') as NodeListOf<HTMLDivElement>
        const webflowTokens: WebflowToken[] = []
        slugArray.forEach((slug) => {
            webflowTokens.push({
                slug: slug.dataset.tokenSlug!,
                icon: slug.dataset.tokenIcon!,
                path: slug.dataset.tokenPath!
            })
        })

        return webflowTokens
    }

    createTokenCell(asset: TokenDO): string {
        const token = this.webflowTokens.find(token => token.slug === asset.slug)
        const path = token?.path
        const iconSrc = token?.icon
        const iconHtml = iconSrc ? `<img src="${iconSrc}" alt="${asset.name}" class="token-icon">` : ''

        return `
            <div class="is-link">
                <a class="caption1" href="/${path}/${asset.slug}">
                    <div class="token-icon-container">
                        ${iconHtml} 
                    </div>
                    ${asset.name}
                </a>
            </div>
        `
    }
}